export default __webpack_public_path__ + "static/ultimate-guide-to-budgeting-d9752e0c269186ce8cc5b646409364b2.jpg";